export enum TypeOfSocials {
  Google = 'google',
  Facebook = 'facebook',
  Apple = 'apple',
}

export interface AppleConnectAuthError {
  error: string;
}

export interface AppleLoginResponse {
  authorization: {
    code: string;
    ['id_token']: string;
    state: string;
  };
  user?: {
    name: {
      firstName: string;
      lastName: string;
    };
    email: string;
  };
}
